import {
  Box,
  CircularProgress,
  Grid,
  Skeleton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IconButton, InputAdornment, MenuItem, TextField } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import DeliveryCompanyListItem from "./DeliveryCompanyListItem";
import { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
const SERVICE_TYPE = [
  "express",
  "sameDay",
  "coldDelivery",
  "heavyAndBulky",
  "lockerDelivery",
  "pudo",
  "bullet",
];
export default function DeliveryCompaniesListContainer({
  companies,
  companiesLoading,
  orderId,
  onAssignedSuccess,
  selectOrder,
  serviceType,
  setServiceType,
}) {
  const { t } = useTranslation();
  const isDownMdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { profile } = useSelector((state) => state.entities.profile);
  const theme = useTheme()
  const handleWhatsAppClick = () => {
    const phone =
      profile?.merchant?.currentStatus === "WAITING"
        ? "966581849999"
        : "966597327471";
    window.open(`https://api.whatsapp.com/send/?phone=${phone}`, "_blank");
  };

  return (
    <Box my={2}>
      <TextField
        sx={{ width: { xs: "100%", sm: "60%", md: "40%" }, my: 2 }}
        select
        label={t("Service Type")}
        size="small"
        fullWidth
        value={serviceType}
        onChange={(e) => setServiceType(e.target.value)}
        InputProps={{
          endAdornment: serviceType ? (
            <InputAdornment position="end" sx={{ pr: 2 }}>
              <IconButton size="small" onClick={() => setServiceType("")}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      >
        {SERVICE_TYPE.map((type) => (
          <MenuItem key={type} value={type}>
            {t(`serviceType.${type}`)}
          </MenuItem>
        ))}
      </TextField>
      <Grid container gap={1} alignItems="center" sx={{ py: 1, px: 1 }}>
        <Grid xs={5} sm={5} md={2.2} item>
          <Box display="flex" alignItems="center">
            <Tooltip
              title={t("mapitShipShipmentTableInfo.Courier")}
              placement="top"
            >
              <InfoOutlined
                sx={{ mr: 0.5, color: "text.lighter" }}
                fontSize="small"
              />
            </Tooltip>
            <Typography variant="subtitle2" fontWeight="bold">
              {t("Courier")}
            </Typography>
          </Box>
        </Grid>
        {!isDownMdScreen && (
          <>
            <Grid md={1} item>
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={t("mapitShipShipmentTableInfo.serviceType")}
                  placement="top"
                >
                  <InfoOutlined
                    sx={{ mr: 0.5, color: "text.lighter" }}
                    fontSize="small"
                  />
                </Tooltip>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("Serivce type")}{" "}
                </Typography>
              </Box>
            </Grid>
            <Grid md={1.2} item>
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={t("mapitShipShipmentTableInfo.deliveryTime")}
                  placement="top"
                >
                  <InfoOutlined
                    sx={{ mr: 0.5, color: "text.lighter" }}
                    fontSize="small"
                  />
                </Tooltip>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("Delivery time")}
                </Typography>
              </Box>
            </Grid>
            <Grid md={1.1} item>
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={t("mapitShipShipmentTableInfo.minimumPackages")}
                  placement="top"
                >
                  <InfoOutlined
                    sx={{ mr: 0.5, color: "text.lighter" }}
                    fontSize="small"
                  />
                </Tooltip>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("Minimum Packages")}
                </Typography>
              </Box>
            </Grid>
            <Grid md={2} item>
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={t("mapitShipShipmentTableInfo.pickupMethod")}
                  placement="top"
                >
                  <InfoOutlined
                    sx={{ mr: 0.5, color: "text.lighter" }}
                    fontSize="small"
                  />
                </Tooltip>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("Pickedup Methods")}
                </Typography>
              </Box>
            </Grid>
            <Grid md={1.5} item>
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={t("mapitShipShipmentTableInfo.deliveryMethod")}
                  placement="top"
                >
                  <InfoOutlined
                    sx={{ mr: 0.5, color: "text.lighter" }}
                    fontSize="small"
                  />
                </Tooltip>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("Delivery Method")}
                </Typography>
              </Box>
            </Grid>
          </>
        )}
        <Grid xs={3} sm={3} md={1} item>
          <Box display="flex" alignItems="center">
            <Tooltip
              title={t("mapitShipShipmentTableInfo.price")}
              placement="top"
            >
              <InfoOutlined
                sx={{ mr: 0.5, color: "text.lighter" }}
                fontSize="small"
              />
            </Tooltip>
            <Typography variant="subtitle2" fontWeight="bold">
              {t("Price")}
            </Typography>
          </Box>
        </Grid>
        <Grid xs={2} sm={2} md={0.8} item></Grid>
      </Grid>
      {!companiesLoading &&
        companies?.deliveryCompany?.map((company, index) => (
          <DeliveryCompanyListItem
            key={index}
            company={company}
            orderId={orderId}
            onAssignedSuccess={onAssignedSuccess}
            selectOrder={selectOrder}
          />
        ))}
      {(!companies?.deliveryCompany?.length && !companiesLoading )&& (
        <>
          <Typography
            textAlign="center"
            variant="body2"
            color="secondary"
            sx={{ mt: 8  , mb: 3}}
          >
            {t("No delivery companies found")}
          </Typography>

          <Typography
            textAlign="center"
            variant="body2"
           
            sx={{ mt: 2 , color:theme.palette.primary.main }}
          >
            {t(
              "To help us find shipping companies that support this city, please",
            )}{" "}
            <Typography
              component="span"
              onClick={handleWhatsAppClick}
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {t("contact us via WhatsApp")}
            </Typography>
          </Typography>
        </>
      )}

      {companiesLoading && (
        <Box mt={3}>
          {Array.from({ length: 4 }).map((_, idx) => (
            <Grid
              key={idx}
              container
              gap={1}
              alignItems="center"
              sx={{ py: 1, px: 1 }}
            >
              <Grid xs={5} sm={5} md={2.2} item>
                <Skeleton variant="text" width="70%" height={24} />
              </Grid>
              {!isDownMdScreen && (
                <>
                  <Grid md={1.4} item>
                    <Skeleton variant="text" width="80%" height={24} />
                  </Grid>
                  <Grid md={1.2} item>
                    <Skeleton variant="text" width="70%" height={24} />
                  </Grid>
                  <Grid md={1.1} item>
                    <Skeleton variant="text" width="70%" height={24} />
                  </Grid>
                  <Grid md={2} item>
                    <Skeleton variant="text" width="80%" height={24} />
                  </Grid>
                  <Grid md={1.5} item>
                    <Skeleton variant="text" width="80%" height={24} />
                  </Grid>
                </>
              )}
              <Grid xs={3} sm={3} md={1} item>
                <Skeleton variant="text" width="60%" height={24} />
              </Grid>
              <Grid xs={2} sm={2} md={0.8} item>
                <Skeleton variant="rounded" width={60} height={30} />
              </Grid>
            </Grid>
          ))}
        </Box>
      )}
    </Box>
  );
}
